const stats = [
  { value: '120+', label: 'Engineers', sub: 'India & Armenia', icon: 'ri-team-line' },
  { value: '15+', label: 'Years Experience', sub: 'Enterprise delivery', icon: 'ri-award-line' },
  { value: '2', label: 'Global Offices', sub: 'Yerevan · Mohali, Chandigarh', icon: 'ri-global-line' },
  { value: '99.99%', label: 'Data Centre Uptime', sub: 'Tier-III grade SLA', icon: 'ri-shield-check-line' },
];

export default function Stats() {
  return (
    <section className="relative bg-background-50 border-b border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((s) => (
            <div
              key={s.label}
              className="relative p-6 md:p-7 rounded-lg bg-background-100 border border-background-200 hover:border-accent-300 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 mb-4">
                <i className={`${s.icon} text-lg`}></i>
              </div>
              <div className="font-heading font-bold text-3xl md:text-4xl text-primary-900">{s.value}</div>
              <div className="mt-1 text-sm font-semibold text-foreground-800">{s.label}</div>
              <div className="text-xs text-foreground-500 mt-0.5">{s.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}